/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useState, } from "react";
import useSWR from 'swr'
import { LuFileDown, LuPrinter, LuStickyNote } from "react-icons/lu";
import { NavBar } from "../../components/NavBar";
import { ModalFiscalCancel } from "../../components/Modals/FiscalCancel";
import { api } from "../../api/api";
import { DateTime } from "luxon";
import { downloadFile, maskCurrency, numOrderFormat } from "../../utils/utils";
import { FiscalContext } from "../../context/FiscalContext";
import { useDispatch } from "react-redux";
import { SELECT_ORDER } from "../../stores/reducers/OrderReducers";
import { GlobalContext } from "../../context/GlobalContext";
import { Toast } from "../../utils/Toast";
import { ModalReportNfe } from "../../components/Modals/ReportNFe";
import { sendPrintNota } from "../../reporting/print";

import './style.css'
import '../admin.css'

export function FiscalPage () {
  const { isAccess, openModalOrder } = useContext(GlobalContext)

  const { setIdOrder } = useContext(FiscalContext)
  const dispatch = useDispatch()

  const [search, setSearch] = useState({
    startDate: DateTime.local().toSQLDate(),
    endDate: DateTime.local().toSQLDate(),
  })

  const { data } = useSWR(['/nfce', search], async (args) => {
    const qs = `?startDate=${args[1].startDate}&endDate=${args[1].endDate}`
    const url = `/nfce${qs}`

    const response = await api.get(url)
    return response.data
  })

  async function orderOpen (id) {
    const response = await api.get(`/orders/${id}`)
    dispatch(SELECT_ORDER(response.data))

    openModalOrder()
  }

  return (
    <>
      <ModalFiscalCancel />
      <ModalReportNfe />
      <NavBar>
        <main className="admin-page fiscal-page">
          <header className="admin-page-header" id="title-fiscal"><div><h1>Fiscal</h1><p>Acompanhe notas fiscais emitidas e canceladas</p></div><div className="admin-header-actions header-filter"><button className="admin-secondary-button" onClick={() => window.print()}><LuPrinter /> <span>Imprimir</span></button><button className="admin-primary-button" onClick={() => {
                  new window.bootstrap.Modal(document.getElementById('modalReportNFe'), {}).toggle()
                }}><LuFileDown /> Gerar relatório</button></div></header>

          <section className="admin-surface">
            <div className="admin-surface-header"><div><h2>Documentos fiscais</h2><p>{data?.length || 0} documentos no período</p></div><LuStickyNote size={19} /></div>
            <div className="admin-filter-bar header-filter fiscal-filter"><label><span>Data inicial</span><input type="date" onChange={(e) => setSearch({ ...search, startDate: e.target.value })} value={search.startDate} /></label><label><span>Data final</span><input type="date" onChange={(e) => setSearch({ ...search, endDate: e.target.value })} value={search.endDate} /></label></div>
            <div className="admin-table-wrap"><table className="admin-table">
              <thead>
                <tr>
                  <th >Cliente</th>
                  <th >Status</th>
                  <th >Data</th>
                  <th >Pedido</th>
                  <th >Nº Nota</th>
                  <th >Valor</th>
                  <th className="th-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((value) => {
                  return (
                    <tr key={value.id}>
                      <td data-label="Cliente"><strong>{value.name || 'Cliente não selecionado'}</strong></td>
                      <td data-label="Status" className="td-status">
                        {value.status === 'Emitida' && <span className="admin-status active">Emitida</span>}
                        {value.status === 'Cancelada' && <span className="admin-status inactive">Cancelada</span>}
                        {(value.status !== 'Emitida' && value.status !== 'Cancelada') && <span className="admin-status processing">Processando</span>}
                      </td>
                      <td data-label="Data">{DateTime.fromISO(value.dataNfe).toLocal().toFormat('dd/MM/yyyy HH:mm')}</td>
                      <td data-label="Pedido"><button className="fiscal-order-link" disabled={!value.numOrder} onClick={() => value.numOrder ? orderOpen(value.idOrder) : null}>
                        {numOrderFormat(value.numOrder)}
                      </button></td>
                      <td data-label="Nº nota">{value?.response?.nfe ? `nº ${value.response.nfe}` : '-'}</td>
                      <td data-label="Valor"><strong>{maskCurrency(value.total)}</strong></td>
                      <td data-label="Ações" className="td-acoes">
                        <div className="dropdown">
                          <button className="admin-secondary-button fiscal-actions-button dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Ações
                          </button>
                          <ul className="dropdown-menu">
                            {(value.status === 'Emitida' && value.status !== 'Cancelada') && (
                              <li><a className="dropdown-item pointer" onClick={() => {
                                if (isAccess('fiscal', 'cancelar')) {
                                  setIdOrder(value.idOrder)
                                  new window.bootstrap.Modal(document.getElementById('fiscalCancel'), {}).toggle()
                                } else {
                                  Toast.warning('Você não tem permissão para cancelar nota.')
                                }
                              }}>Cancelar</a></li>
                            )}
                            {value.status === 'Emitida' && (
                              <>
                                <li><a className="dropdown-item pointer" onClick={() => {
                                  if (value.response) {
                                    sendPrintNota({ idNota: value.id })
                                  }
                                }}>Imprimir</a></li>

                                <li><a className="dropdown-item pointer" onClick={() => {
                                  if (value.response) {
                                    downloadFile(value.response.xml, `${value.response.chave}.xml`)
                                  }
                                }}>Baixar XML</a></li>
                              </>
                            )}
                            {value.status === 'Cancelada' && (
                              <>
                                <li><a className="dropdown-item pointer" onClick={() => {
                                  if (value.response) {
                                    downloadFile(value.responseCancelamento.xml, `${value.response.chave}.xml`)
                                  }
                                }}>Baixar XML</a></li>
                              </>
                            )}
                          </ul>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}></td>
                  <td data-label="Total"><strong>Total: {maskCurrency(data?.reduce((prev, current) => prev + (current?.total ?? 0), 0))}</strong></td>
                  <td className="td-acoes"></td>
                </tr>
              </tfoot>
            </table></div>
            {data?.length === 0 && <div className="admin-empty"><LuStickyNote size={25} /><strong>Nenhum documento encontrado</strong><span>Altere o período para consultar outras notas.</span></div>}
          </section>
        </main>
      </NavBar>
    </>
  )
}
